import { render, staticRenderFns } from "./CustomerAdminAccounts.vue?vue&type=template&id=2aae2e1e&scoped=true"
import script from "./CustomerAdminAccounts.vue?vue&type=script&lang=ts"
export * from "./CustomerAdminAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae2e1e",
  null
  
)

export default component.exports